module.exports = __webpack_public_path__ + "static/media/e&oHead.d290febb.jpg";